/* GOWin® Store — carrito v5: resumen subtotal / descuentos / envío / total + jerarquía de recompensas */
(() => {
  if (window.GowinCartFeedStyleV5) return;
  window.GowinCartFeedStyleV5 = true;

  const DATA_SELECTOR = '[data-gowin-cart-summary-data]';
  let observer;
  let observedDrawer;
  let scheduled = false;

  const readData = (drawer) => {
    const node = drawer.querySelector(DATA_SELECTOR);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('GOWin: no se pudo leer el resumen del carrito.', error);
      return null;
    }
  };

  const makeRow = (label, value, modifier = '') => {
    const row = document.createElement('div');
    row.className = `gowin-cart-summary__row${modifier ? ` gowin-cart-summary__row--${modifier}` : ''}`;

    const labelNode = document.createElement('span');
    labelNode.className = 'gowin-cart-summary__label';
    labelNode.textContent = label;

    const valueNode = document.createElement('strong');
    valueNode.className = 'gowin-cart-summary__value';
    valueNode.textContent = value;

    row.append(labelNode, valueNode);
    return row;
  };

  const normalizeText = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .trim();

  const moneyToken = (value) => {
    const match = String(value || '').match(/₡\s*[\d.,]+/);
    return match ? match[0].replace(/\s+/g, '') : '';
  };

  const dedupeShippingProgressCopy = (drawer) => {
    const status = drawer.querySelector('[data-gowin-drawer-shipping] .gowin-drawer-shipping__status');
    const title = status?.querySelector('.gowin-drawer-shipping__title');
    const meta = status?.querySelector('.gowin-drawer-shipping__progress-meta');
    const helper = meta?.querySelector(':scope > span');
    const percent = meta?.querySelector(':scope > strong');
    if (!title || !meta || !helper) return false;

    const titleText = normalizeText(title.textContent);
    const helperText = normalizeText(helper.textContent);
    const titleMoney = moneyToken(title.textContent);
    const helperMoney = moneyToken(helper.textContent);
    const duplicate = Boolean(
      titleText.includes('te faltan') &&
      helperText.startsWith('faltan') &&
      titleMoney &&
      helperMoney &&
      titleMoney === helperMoney
    );

    helper.hidden = duplicate;
    if (duplicate) helper.setAttribute('aria-hidden', 'true');
    else helper.removeAttribute('aria-hidden');

    if (percent) percent.style.marginLeft = duplicate ? 'auto' : '';
    return duplicate;
  };

  const hasRewardsCopy = (element) => {
    if (!(element instanceof Element)) return false;
    const text = normalizeText(element.textContent);
    return (
      text.includes('al completar tu pedido') &&
      text.includes('recompensas') &&
      text.includes('gowin')
    );
  };

  const parentBelongsOnlyToRewards = (element) => {
    if (!(element instanceof Element) || !hasRewardsCopy(element)) return false;
    const text = normalizeText(element.textContent);
    return !(
      text.includes('subtotal') ||
      text.includes('total estimado') ||
      text.includes('pagar pedido') ||
      element.querySelector('.cart-drawer__footer, .cart__ctas')
    );
  };

  const findRewardsBlock = (drawer) => {
    const candidates = Array.from(
      drawer.querySelectorAll('p, span, div, section, aside')
    ).filter(hasRewardsCopy);

    if (!candidates.length) return null;

    candidates.sort((a, b) => {
      const aText = normalizeText(a.textContent).length;
      const bText = normalizeText(b.textContent).length;
      return aText - bText || a.children.length - b.children.length;
    });

    let block = candidates[0];
    let current = block;
    let depth = 0;

    while (current.parentElement && current.parentElement !== drawer && depth < 7) {
      const parent = current.parentElement;
      if (!drawer.contains(parent) || !parentBelongsOnlyToRewards(parent)) break;

      const style = window.getComputedStyle(parent);
      const hasVisibleBox =
        style.backgroundColor !== 'rgba(0, 0, 0, 0)' &&
        style.backgroundColor !== 'transparent';
      const hasRadius = parseFloat(style.borderTopLeftRadius || '0') >= 4;
      const isSingleChildWrapper = parent.children.length === 1;
      const semanticContainer = ['SECTION', 'ASIDE'].includes(parent.tagName);

      if (!(hasVisibleBox || hasRadius || isSingleChildWrapper || semanticContainer)) break;

      block = parent;
      current = parent;
      depth += 1;
    }

    return block;
  };

  const arrangeRewardsHierarchy = (drawer) => {
    const footer = drawer.querySelector('.drawer__footer');
    const totalsBox = footer?.querySelector(':scope > .cart-drawer__footer');
    if (!footer || !totalsBox) return false;

    const creditPanel = footer.querySelector(':scope > [data-gowin-store-credit-panel]');
    const rewardsBlock = findRewardsBlock(drawer);

    if (rewardsBlock && rewardsBlock !== totalsBox && !rewardsBlock.contains(totalsBox)) {
      rewardsBlock.setAttribute('data-gowin-rewards-before-totals', 'true');

      if (creditPanel && creditPanel !== rewardsBlock) {
        if (rewardsBlock.nextElementSibling !== creditPanel || rewardsBlock.parentElement !== footer) {
          footer.insertBefore(rewardsBlock, creditPanel);
        }

        if (creditPanel.nextElementSibling !== totalsBox) {
          footer.insertBefore(creditPanel, totalsBox);
        }

        return (
          rewardsBlock.parentElement === footer &&
          rewardsBlock.nextElementSibling === creditPanel &&
          creditPanel.nextElementSibling === totalsBox
        );
      }

      if (rewardsBlock.nextElementSibling !== totalsBox || rewardsBlock.parentElement !== footer) {
        footer.insertBefore(rewardsBlock, totalsBox);
      }

      return rewardsBlock.parentElement === footer && rewardsBlock.nextElementSibling === totalsBox;
    }

    if (creditPanel && creditPanel.nextElementSibling !== totalsBox) {
      footer.insertBefore(creditPanel, totalsBox);
    }

    return Boolean(creditPanel && creditPanel.nextElementSibling === totalsBox);
  };

  const enhance = () => {
    scheduled = false;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    dedupeShippingProgressCopy(drawer);
    arrangeRewardsHierarchy(drawer);

    const data = readData(drawer);
    const footer = drawer.querySelector('.drawer__footer .cart-drawer__footer');
    if (!data || !footer) return;

    const signature = [data.subtotal, data.discount, data.discountCents, data.shippingQualified, data.shipping, data.total].join('|');
    let summary = footer.querySelector('.gowin-cart-summary');

    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'gowin-cart-summary';
      summary.setAttribute('role', 'status');
      summary.setAttribute('aria-live', 'polite');
      const totals = footer.querySelector('.totals');
      footer.insertBefore(summary, totals || footer.firstChild);
    }

    if (summary.dataset.gowinSummarySignature !== signature) {
      const discountText = Number(data.discountCents || 0) > 0 ? `−${data.discount}` : data.discount;
      const fragment = document.createDocumentFragment();
      fragment.append(
        makeRow('Subtotal', data.subtotal),
        makeRow('Descuentos', discountText, 'discount'),
        makeRow('Envío', data.shipping, data.shippingQualified ? 'shipping-free' : 'shipping'),
        makeRow('Total estimado', data.total, 'total')
      );
      summary.replaceChildren(fragment);
      summary.dataset.gowinSummarySignature = signature;
    }

    footer.classList.add('gowin-cart-summary-ready');
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  };

  const bind = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (drawer !== observedDrawer) {
      observer?.disconnect();
      observer = new MutationObserver(schedule);
      observer.observe(drawer, {
        childList: true,
        subtree: true,
        characterData: true
      });
      observedDrawer = drawer;
    }
    schedule();
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind, { once: true })
    : bind();

  document.addEventListener('gowin:cart-patched', enhance);
  document.addEventListener('cart:updated', bind);
  document.addEventListener('cart:refresh', bind);
  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('pageshow', bind);
})();
